import { render, staticRenderFns } from "./studentfeedback.vue?vue&type=template&id=d2e479e4&scoped=true"
import script from "./studentfeedback.vue?vue&type=script&lang=js"
export * from "./studentfeedback.vue?vue&type=script&lang=js"
import style0 from "./studentfeedback.vue?vue&type=style&index=0&id=d2e479e4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e479e4",
  null
  
)

export default component.exports